import React, {useEffect, useState , useCallback } from "react";
import styled from "@emotion/styled";
import { Container } from "./style/layout";
import { SearchForm } from "./SearchForm";
import { SearchFormWhite } from "./SearchFormWhite";
import { Box } from "./Box";
import { Badges } from "./Badges";
import { Headline } from "./Headline";
import { SearchResults } from "../Components/SearchResults";
import { CurrencyContext } from "../Context/Currency";
import { RenderContext } from "../Context/Ssr";
import { CatalogContext } from "../Translator/withTranslation";
import { LocaleContext } from "../Context/Locale";
import { PopularPeriodBanner } from "./PopularPeriodBanner";
import { SaturdayArrivalBanner } from "./SaturdayArrivalBanner";

const MainContent = styled.div`
  width: 100%;
  max-width: 1290px;
  width: calc(100vw - 10%);
  align-self: center;
  display: flex;
  flex-direction: column;
  align-content: center;
  margin: 0 auto;

  @media (max-width: 1200px) {
    width: 100%;
  }
`;

const HeroContainer = styled.div`
  display: flex;
  background-image: url(${({ searchURLBase }) =>  searchURLBase ? searchURLBase : ""}/assets/img/front/clubvillamar-hero-image.${({ webpSupported }) => webpSupported ? 'webp' : 'jpg' });
  background-size: cover;
  background-position: top center;
  height: calc(100vw/3);
  max-height: 600px;

  @media (max-width: 1023px) {
    height:auto;
    min-height: 575px;
    max-height: fit-content;
    background-position: 10% 0%;
  }
  @media (max-width: 767px) {
    display: block;
    background-image: url(${({ searchURLBase }) => searchURLBase ? searchURLBase : ""}/assets/img/front/clubvillamar-hero-image.${({ webpSupported }) => webpSupported ? 'webp' : 'jpg' });
    background-size: cover;
    background-position: 20% 0%;
    height: max-content;
  }
`;

const SearchFormBoxComponent = (props) =>  {
  const [mobile, setMobile] = useState(props.mobile);
  const [tablet, setTablet] = useState(props.tablet);
  const [page, setPage] = useState(props.page);
  const [queryString, setQueryString] = useState(props.initial_query);
  const [queryResult, setQueryResult] = useState(props.queryResult);

  const resizeHandler = (e) => {
    setMobile(e.detail.properties.mobile);
    setTablet(e.detail.properties.tablet);
  }


  useEffect( () => {
          document.addEventListener("CheckWindowResize", resizeHandler);
          return () => {
              document.removeEventListener("CheckWindowResize", resizeHandler);
          };
      }, [mobile, setMobile, tablet, setTablet]
  );

  const onChange = useCallback((data) => {
    setQueryResult(data.queryResult);
    setQueryString(data.queryString);
  });

  const onPageChange = useCallback( (page) => {
    setPage(page);
    if(typeof document !== 'undefined') {
      const indexText = document.getElementById('IndexText');
      if (indexText) { 
        document.getElementById('IndexText').style.display = (page == 1  ? "block" :  "none");
      }
    }
  });

  const SearchFormWithProps =
      <SearchForm
        onChange={data => onChange(data)}
        onPageChange={page => onPageChange(page)}
        initial_query={props.initial_query}
        currency={props.currency}
        queryString={queryString}
        queryResult={queryResult}
        mobile={mobile}
        maxSleepsType={props.maxSleepsType}
        tablet={tablet}
        hideResults={props.hideResults}
        updateURL={props.updateURL}
        defaultQuery={props.defaultQuery}
        priceRangeSettings={props.priceRangeSettings}
        perpage={props.perpage}
        searchFieldsOnly={props.searchFieldsOnly}
        slideshowImages={props.slideshowImages}
        page={page}
        extendSearchOpenCallback={props.extendSearchOpenCallback}
        extendSearchClosedCallback={props.extendSearchClosedCallback}
        searchURLBase={props.searchURLBase}
        locale={props.locale}
        sortBy={props.sortBy}
        arrivalOffset={props.arrivalOffset}
      />
  ;
  const SearchFormWhiteWithProps =
      <SearchFormWhite
        onChange={data => onChange(data)}
        onPageChange={page => onPageChange(page)}
        initial_query={props.initial_query}
        currency={props.currency}
        queryString={queryString}
        queryResult={queryResult}
        mobile={mobile}
        maxSleepsType={props.maxSleepsType}
        tablet={tablet}
        hideResults={props.hideResults}
        updateURL={props.updateURL}
        defaultQuery={props.defaultQuery}
        priceRangeSettings={props.priceRangeSettings}
        perpage={props.perpage}
        searchFieldsOnly={props.searchFieldsOnly}
        slideshowImages={props.slideshowImages}
        page={page}
        extendSearchOpenCallback={props.extendSearchOpenCallback}
        extendSearchClosedCallback={props.extendSearchClosedCallback}
        searchURLBase={props.searchURLBase}
        locale={props.locale}
        sortBy={props.sortBy}
        arrivalOffset={props.arrivalOffset}
      />
  ;

  return (
      <div className={props.className ? props.className : ""}>
        <HeroContainer searchURLBase={props.searchURLBase} webpSupported={props.webpSupported}>
          <Container flexDirection="column">
            {mobile ? (
              <div className="py-6">
                <div>
                  {!props.hideHeadline ? <Headline mobile={true} /> : ""}
                  {(props.searchFormMultiVariateBucket === 'white') ? SearchFormWhiteWithProps : SearchFormWithProps }
                </div>
              </div>
            ) : (
              <div className="py-sm-3 pt-5 pb-6 mt-md-6 mx-3">
                <MainContent
                  className={
                    !props.hideHeadline &&
                    !tablet &&
                    !mobile
                      ? "pt-0"
                      : ""
                  }
                >
                  {!props.hideHeadline ? (
                    <Box mb={54}>
                      <Headline />
                    </Box>
                  ) : (
                    ""
                  )}
                  {(props.searchFormMultiVariateBucket === 'white') ? SearchFormWhiteWithProps : SearchFormWithProps }
                </MainContent>
              </div>
            )}
            {
              <SaturdayArrivalBanner query={queryString} />
            }
            {/* {
              <PopularPeriodBanner query={queryString} />
            } */}
            {!mobile && !tablet && !props.hideBadges ? (
              <div className="bg-grey3">
                <Badges {...props} />
              </div>
            ) : (
              ""
            )}
          </Container>
        </HeroContainer>
        {(Object.keys(props.seo).length > 0  && props.seo.title !== '' && props.seo.title !== null) ? (<h1 className={ mobile || tablet ? "bg-blue3 white text-center px-5 py-2 mb-0 container-full-width font-120" : "bg-blue3 white text-center px-3 py-2 mb-0 container-full-width font-200"} dangerouslySetInnerHTML={{__html: props.seo.title}}></h1> ) : ''}
        {!props.hideResults ? (
          <SearchResults
            className="mb-4"
            currency={props.currency}
            favouriteVillas={props.favouriteVillas}
            mobile={mobile}
            page={page}
            queryResult={queryResult}
            queryString={queryString}
            receiveItems={true}
            perpage={props.perpage}
            showMap={props.showMap}
            slideshowImages={props.slideshowImages}
            slideshowImagesPreloadCount={props.slideshowImagesPreloadCount}
            slideshowImagesLazyloadNext={props.slideshowImagesLazyloadNext}
            scrollLoadFrom={props.searchResultsScrollLoadFrom}
            sortBy={props.sortBy}
            tablet={tablet}
            updateURL={props.updateURL}
            viewedVillas={props.viewedVillas}
            hideMapButton={props.hideMapButton}
            hideGridButton={props.hideGridButton}
            onPageChange={(page) => onPageChange(page)}
            locale={props.locale}
          />
        ) : (
          ""
        )}
      </div>
    );
}

export const SearchFormBox = (initialProps, context) => {
  return (
    <LocaleContext.Provider value={initialProps.locale}>
      <CatalogContext.Provider value={initialProps.catalog}>
        <RenderContext.Provider value={context}>
          <CurrencyContext.Provider value={initialProps.currency}>
            <SearchFormBoxComponent {...initialProps} />
          </CurrencyContext.Provider>
        </RenderContext.Provider>
      </CatalogContext.Provider>
    </LocaleContext.Provider>
  );
};
